import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaToggleOn } from 'react-icons/fa';
import { FaPlus, FaTrash } from 'react-icons/fa6';
import CustomizationManagePopUp from './customizationManagePopUp';
import { DisableCategoryGroupService } from '../../Services/incidentCategoryService';
import { useTranslation } from 'react-i18next';
import MessagePopUp from '../common/messagePopUp';
import { DisableCustomQuestionGroupService } from '../../Services/customQuestionsService';

const CustomizationCards = ({ data, company, reloadData, question = false }) => {

    const [t] = useTranslation("companies");
    const [showManagePopUp, setShowManagePopUp] = useState(false);
    const [manageData, setManageData] = useState(false);
    const [manageDataName, setManageDataName] = useState(false);
    const [popupMessage, setPopupMessage] = useState({});
    const [showPopUpDelete, setShowPopUpDelete] = useState(false);


    const COLOR = {
        0: "status-red",
        1: "status-yellow",
        2: "status-blue",
        3: "status-green",
    };

    const LANG = {
        'es': "Español",
        'ca': "Catalá",
        'eu': "Euskara",
        'en': "English",
        'it': "Italiano",
    };

    // Agrupar los datos por categoryGroup y ordenarlos
    const languageOrder = {
        "es": 1,
        "ca": 2,
        "eu": 3,
        "en": 4,
        "it": 5,
    };


    let groups;
    if (question) {
        groups = data.reduce((acc, item) => {
            // Agrupar los elementos
            acc[item.questionGroup] = acc[item.questionGroup] || [];
            acc[item.questionGroup].push(item);

            // Ordenar el grupo actual
            acc[item.questionGroup].sort((a, b) => {
                return languageOrder[a.language] - languageOrder[b.language];
            });

            return acc;
        }, {});
    } else {
        groups = data.reduce((acc, item) => {
            // Agrupar los elementos
            acc[item.categoryGroup] = acc[item.categoryGroup] || [];
            acc[item.categoryGroup].push(item);

            // Ordenar el grupo actual
            acc[item.categoryGroup].sort((a, b) => {
                return languageOrder[a.language] - languageOrder[b.language];
            });

            return acc;
        }, {});
    }

    // Filtrar grupos donde todos los elementos tienen enabled: false
    for (const group in groups) {
        if (groups[group].every(item => !item.enabled)) {
            delete groups[group];
        }
    }

    // Convertir groups en un array de objetos, cada uno con su clave y valor
    let groupsArray = Object.keys(groups).map(key => {
        return {
            key: key,
            value: groups[key],
            oldestCreatedAt: groups[key].reduce((oldest, item) => {
                return (oldest === null || item.createdAt < oldest) ? item.createdAt : oldest;
            }, null)
        };
    });

    // Ordenar el array por la fecha más antigua
    groupsArray.sort((a, b) => {
        return new Date(a.oldestCreatedAt) - new Date(b.oldestCreatedAt);
    });

    // Convertir el array ordenado de nuevo en un objeto
    groups = groupsArray.reduce((acc, groupObj) => {
        acc[groupObj.key] = groupObj.value;
        return acc;
    }, {});





    const handleManagePopUpClose = () => {
        setShowManagePopUp(false);

        //esperar para que no se vea el cambio
        setTimeout(() => {
            setManageData(false);
            setManageDataName(false);
        }, 500);
    }

    const handleAddClick = () => {
        setShowManagePopUp(true);
    }

    const handleEditClick = (group, name) => {
        setManageData(group)
        setManageDataName(name);
        setShowManagePopUp(true);
    }

    const handleDelete = (group, name) => {
        let messageTitle = "";
        let messageBody = "";

        if (question) {
            messageTitle = `${t("customizationCard.deleteTitle")}`
            messageBody = `${t("customizationCard.deleteText")}: <b>${name}</b><br/><br/><p>${t("customizationCard.deleteText3")}</p>`;
        } else {
            messageTitle = `${t("customizationCard.deleteTitle")}`
            messageBody = `${t("customizationCard.deleteText")}: <b>${name}</b><br/><br/><p>${t("customizationCard.deleteText2")}</p>`;
        }

        if (question) {
            setPopupMessage({ title: messageTitle, body: messageBody, group: group[0].questionGroup });

        } else {
            setPopupMessage({ title: messageTitle, body: messageBody, group: group[0].categoryGroup });

        }
        setShowPopUpDelete(true)
    }


    const handleDeleteConfirmClick = async (group) => {

        if (question) {
            const response = await DisableCustomQuestionGroupService(group);
        } else {
            const response = await DisableCategoryGroupService(group);
        }
        setShowPopUpDelete(false);
        reloadData()
    }
    return (
        <>
            <MessagePopUp
                show={showPopUpDelete}
                handleClose={() => setShowPopUpDelete(false)}
                title={popupMessage.title}
                textBody={popupMessage.body}
                buttonText={t("customizationCard.confirmButton")}
                cancelButtonText={t("customizationCard.cancelButton")}
                onClickCancelButton={() => setShowPopUpDelete(false)}
                onClickButton={() => handleDeleteConfirmClick(popupMessage.group)}
            />

            <CustomizationManagePopUp
                handleClose={handleManagePopUpClose}
                show={showManagePopUp}
                title={manageData ? `${t("customizationCard.edit")} ${manageDataName}` : `${t("customizationCard.create")} ${question ? t("customizationCard.question") : t("customizationCard.category")}`}
                buttonSendText={manageData ? t("customizationCard.edit") : t("customizationCard.create")}
                data={manageData}
                key={showManagePopUp}
                company={company}
                handleReloadData={reloadData}
                question={question}
            />


            <div className={`customization-card-container width-95 mx-auto ${Object.keys(groups).length >= 4 ? 'justify-content-around' : ''}`}>
                {Object.keys(groups).map((group, index) => (
                    <div key={group} className='customization-card-card custom-shadow-bold' onClick={() => handleEditClick(groups[group], `${question ? t("customizationCard.questionUPP") : t("customizationCard.categoryUPP")} ${index + 1}`)}>
                        <div className='customization-card-body'>
                            <Button
                                onClick={(e) => { handleDelete(groups[group], `${question ? t("customizationCard.questionUPP") : t("customizationCard.categoryUPP")} ${index + 1}`); e.stopPropagation() }}
                                className="custom-shadow-bold enable-button customization-card-disable-button"
                            >
                                <FaTrash size={17} />
                            </Button>
                            <div className='customization-card-title font-bold'>{`${question ? t("customizationCard.questionUPP") : t("customizationCard.categoryUPP")} ${index + 1}`}</div>
                            <div className='customization-card-content'>
                                {groups[group].map((item) => (
                                    <div key={item.name}>
                                        <span className='customization-card-content-text'><b>{LANG[item.language]}:</b> {question ? item.title : item.name}</span>
                                    </div>
                                ))}
                            </div>
                            <div className={`case-card-color-identifier ${COLOR[index % Object.keys(COLOR).length]}`}></div>
                        </div>
                    </div>
                ))}

                {
                    Object.keys(groups).length < 4 && (
                        <div className='customization-card-add-button custom-shadow-bold' onClick={handleAddClick}>
                            <FaPlus size={30} />
                            <span className='font-bold'>{t("customizationCard.add")}</span>
                        </div>
                    )
                }

            </div>
        </>
    );
}

export default CustomizationCards;
